import React from 'react';
import Danger from '/public/icons/danger-triangle.svg';

const DANGER_ICON_VIEW_BOX = '0 0 21 20';

export function AuditLogsError() {
  return (
    <div className="w-fit rounded-lg border border-red-500 bg-[#FFF5F5] px-6 py-5 max-md:w-full max-md:rounded-xl max-md:bg-red-500/4 max-md:p-4">
      <div className="flex items-start gap-3 max-md:items-center max-md:gap-4">
        <Danger
          viewBox={DANGER_ICON_VIEW_BOX}
          className="w-5 h-5 shrink-0 mt-0.5 max-md:h-6 max-md:w-6 max-md:self-start"
        />
        <div className="flex flex-col gap-1 max-md:justify-center max-md:gap-0.5">
          <span className="font-inter text-base font-semibold leading-6 text-red-500 max-md:text-sm max-md:leading-[150%]">
            Unable to load audit logs
          </span>
          <span className="font-inter text-sm font-normal leading-[19.6px] text-grey-700 max-md:leading-[150%]">
            Please refresh the page or try again later.
          </span>
        </div>
      </div>
    </div>
  );
}
